import React from 'react';

export const ListIcon = (props: React.HTMLAttributes<SVGElement>) => (
  <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2" y="3" width="12" height="1" rx="0.5" fill="currentColor" />
    <rect x="2" y="6" width="12" height="1" rx="0.5" fill="currentColor" />
    <rect x="2" y="9" width="12" height="1" rx="0.5" fill="currentColor" />
    <rect x="2" y="12" width="12" height="1" rx="0.5" fill="currentColor" />
  </svg>
);
